import { observer } from 'mobx-react';
import * as React from 'react';
import { PleaseWait } from '../../comps/PleaseWait';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { DashboardBody } from './DashboardBody';

@observer export class GDashboard extends OcScreen<{}> {
	name() {
		return 'GDashboard';
	}

	allowScroll() {
		return true;
	}

	usedStores = () => ['Order', 'User', 'Template']

	renderBody() {
		const orderStore = getOmnistore().multirepo.orderRepo;
		if (!orderStore.etag) return <PleaseWait/>;
		return <DashboardBody orders={orderStore.allAsList}/>;
	}
}
